import React, {Component} from "react";
import {Button} from "reactstrap";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";

/**
 * Input properties:
 * <br>isActive:  Determine the current state as active or inactive for the item being changed.
 * <br>description: Used in the confirmation message so that we know what we are activating or deactivating
 * <br>item:  passed to the activation function so the activation deactivation function knows what to operate on
 * <br>toggleFunction: The name of the function to be called to handle the activation or inactivation.  It should expect the item object to be passed
 * <br>header: Define what the message header should be.  It will start with Deactivate or Activate - then header
 */
export default class ActivationButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmModal: false
        }
    }

    getMessage = () => {
        const action = this.props.isActive ? "deactivate" : "activate";
        return `Are you sure you want to ${action} ${this.props.description}?`
    }

    getConfirmButtonName = () => {
        return this.props.isActive ? "Deactivate" : "Activate";
    }

    render() {
        return (
            <span>
                <Button
                    onClick={() => this.setState({
                        confirmModal: true
                    })}
                    outline
                    color={this.props.isActive ? "warning" : "success"}
                    className={`btn`}
                    size="sm"
                >
                    {this.getConfirmButtonName()}
                </Button>
                {/* Add product first dialog*/}
                <ConfirmDialog
                    toggleState={this.state.confirmModal}
                    cancelAction={() =>
                        this.setState({confirmModal: false})
                    }
                    message={this.getMessage()}
                    confirmAction={() => {
                        this.setState({
                            confirmModal: false
                        })
                        this.props.toggleFunction(this.props.item)
                    }
                    }
                    confirmActionName={this.getConfirmButtonName()}
                    confirmClassName={"btn-warning"}
                    caption={`${this.getConfirmButtonName()} ${this.props.header}.`}
                />
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/common/ActivationButton/ActivationButton.js